import { useState } from "react";
import { Drawer, Button, Typography, Input } from "antd";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import TemplateItem from "./TemplateItem";
import AddTemplateModal from "./AddTemplateModal";

const { Title } = Typography;
const { Search } = Input;

const TemplateDrawer = ({
  isOpen,
  onClose,
  templates,
  editMode,
  setEditMode,
  onDragEnd,
  isDragging,
  onDragStart,
  onTemplateSelect,
  onEditTemplate,
  onAddTemplate
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredTemplates = templates.filter(template =>
    template.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Drawer
      title="Templates"
      placement="left"
      onClose={onClose}
      open={isOpen}
      width={450}
      footer={[
        <Button key="add-faq" type="primary" className="m-2" onClick={onAddTemplate}>
          Add New
        </Button>,
        <Button 
          key="toggle-edit" 
          type={editMode ? "default" : "primary"} 
          onClick={() => setEditMode(!editMode)}
          className="m-2"
        >
          {editMode ? "Cancel Edit" : "Edit Templates"}
        </Button>,
      ]}
    >
      <div className="search-container" style={{ marginBottom: 16 }}>
        <Search
          placeholder="Search templates..."
          allowClear
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: '100%' }}
        />
      </div>

      <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
        <Droppable droppableId="templates">
          {(provided) => (
            <div 
              className="templates-list" 
              {...provided.droppableProps} 
              ref={provided.innerRef}
            >
              {filteredTemplates
                .sort((a, b) => a.position - b.position)
                .map((template, index) => (
                  <TemplateItem
                    key={template._id}
                    template={template}
                    index={index}
                    editMode={editMode}
                    isDragging={isDragging}
                    onTemplateSelect={onTemplateSelect}
                    onEditTemplate={onEditTemplate}
                  />
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <style jsx>{`
        .templates-list {
          max-height: calc(100vh - 220px);
          overflow-y: auto;
        }
      `}</style>
    </Drawer>
  );
};

export default TemplateDrawer;